// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataBuffer } from '../DataBuffer.js';
import { PFixFieldSet } from './FieldsImport.js';
import { PFixGroupField } from './PFixGroupField.js'
export let PFixLongGroupField = function (fieldId, buffer)
{
    PFixGroupField.call(this, fieldId, buffer)
}

PFixLongGroupField.prototype = Object.create(PFixGroupField.prototype);

PFixLongGroupField.prototype.ReadValue = function (buffer)
{
    var id = buffer.ReadInt32();
    var fieldSet = new PFixFieldSet(id);

    var size = buffer.ReadInt32();
    var groupBuffer = buffer.ReadBuffer(size);

    fieldSet.Read(groupBuffer);
    this.Value = fieldSet;
};

PFixLongGroupField.prototype.Write = function (buffer, maxServerNumber)
{
    var fieldSet = this.Value;

    buffer.WriteShort(this.FieldId);
    buffer.WriteInt32(fieldSet.GroupId);//write group name	    

    var groupBuffer = new DataBuffer();
    fieldSet.Write(groupBuffer, maxServerNumber);

    buffer.WriteInt32(groupBuffer.Length);
    buffer.WriteBuffer(groupBuffer);
};